export const SET_CONDITIONS_PAGE = "setConditionsPage";
